import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { EmpresaAdminStore } from "../../stores/admin/EmpresaAdminStore";
import { formatCnpj } from "../../utils";
import { AppStore } from "../../stores/AppStore";
import { IconButton } from "@mui/material";
import { Button, Callout, Checkbox, Classes, Dialog, Divider, FormGroup, HTMLSelect, HTMLTable, Icon, InputGroup, NumericInput, Radio, RadioGroup, Switch, Tab, Tabs } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import moment from "moment";
import { SenhaCopiavel } from "./SenhaCopiavel";
import { UserCopiavel } from "./UserCopiavel";
import { AppIcon } from "../utils/AppIcon";
import { toast } from "react-toastify";
import LoadingModal from "../loading/LoadingModal";
import { JsonEditor } from "json-edit-react";

var debounce = require('lodash.debounce');

interface Props { }

interface State {
  visivel: boolean
}

const CAMPOS_CNPJ = [
  { key: 'razao_social', label: 'Razão social', tipo: 'texto' },
  { key: 'nome_fantasia', label: 'Nome fantasia', tipo: 'texto' },
  { key: 'logradouro', label: 'Logradouro', tipo: 'texto' },
  { key: 'numero', label: 'Número', tipo: 'texto' },
  { key: 'complemento', label: 'Complemento', tipo: 'texto' },
  { key: 'bairro', label: 'Bairro', tipo: 'texto' },
  { key: 'municipio', label: 'Município', tipo: 'texto' },
  { key: 'uf', label: 'UF', tipo: 'texto' },
  { key: 'cep', label: 'CEP', tipo: 'digitos' },
  { key: 'abertura', label: 'Data de abertura', tipo: 'data' },
]

@observer
export class EmpresasAdminPage extends React.Component<Props, State> {

  obs = observable({
    currentPage: 1 as number,
    filters_empresa: { razao_social: "", cnpj: "", municipio: "", uf: "", regime_importacao: "", ativo: "0" },
    filters_conta: { nome: "", razao_social: "", cnpj: "", ativo: "0" },
    open_filters: false,
    open_modal_detalhes: false,
    itens: {} as any,
    fetchOptions: {} as any,

    open_modal_edit: false,
    loading_dados: false,
    loading_save: false,
    days: "60" as string,
    new_values: null as any,
    aprovados: {} as Record<string, boolean>,

    lista_rbt12: [] as any[],
    lista_rbt12_externa: [] as any[],

    loading_rbt12: false,
    rbt12_loaded: false,
    rbt12_alterado: false,

    selectedTab: "empresa" as string,
  })

  get diffCampos() {
    if (!this.obs.new_values) return []
    return this.montaDiff(this.obs.itens, this.obs.new_values)
  }

  get linhasAlteradas() {
    return this.diffCampos.filter(l => l.alterado)
  }

  get qtdSemAlteracao(): number {
    return this.diffCampos.length - this.linhasAlteradas.length
  }

  get qtdSelecionadas(): number {
    return this.linhasAlteradas.filter(l => this.obs.aprovados[l.key]).length
  }

  get todasMarcadas(): boolean {
    return this.linhasAlteradas.length > 0 &&
      this.qtdSelecionadas === this.linhasAlteradas.length
  }

  constructor(props) {
    super(props);

    this.obs.fetchOptions = debounce(this.handlePageChange.bind(this), 800);

    this.state = {
      visivel: false
    };

  }

  async componentDidMount(): Promise<void> {
    AppStore.setTitle("Empresas Admin");

    await EmpresaAdminStore.handleLoadEmpresas(1, this.obs.filters_empresa, this.obs.filters_conta)

  }

  async handlePageChange(page) {

    this.obs.currentPage = page

    await EmpresaAdminStore.handleLoadEmpresas(page, this.obs.filters_empresa, this.obs.filters_conta)

  }

  handleQueryFilters(e) {

    this.obs.fetchOptions(1)

  }

  openDetalhesEmpresa(row) {

    this.obs.itens = row

    this.obs.open_modal_detalhes = true

  }

  handleClearFiltros() {

    this.obs.open_filters = false

    this.obs.filters_empresa = { razao_social: "", cnpj: "", municipio: "", uf: "", regime_importacao: "", ativo: "0" }

    this.obs.filters_conta = { nome: "", razao_social: "", cnpj: "", ativo: "0" }

    this.handlePageChange(1)

  }

  formatterModeloLogin(modelo) {

    switch (modelo) {
      case "certificado": return "Certificado do Sócio"
      case "senha": return "CPF e Senha"
      case "gov": return "GOV (Certificado)"
      case "gov_senha": return "GOV (CPF / Senha)"
      default: return "Nenhum modelo selecionado"
    }

  }

  async handleDownloadPfx(empresa: string, conta_id: string, senha: string, tipo: string) {

    await EmpresaAdminStore.downloadEmpresaPfx(empresa, conta_id, senha, tipo)

  }

  certificadoFormat(certificado: string) {

    const startDate = moment().toDate();

    const dataHoje = moment(startDate).format("YYYY-MM-DD");

    if (certificado <= dataHoje) {

      return (<span style={{ color: "red" }}>Expirado (Val: {moment(certificado).format("DD/MM/YYYY")})</span>)

    } else {

      return (<span style={{ color: "green" }}>Vigente (Val: {moment(certificado).format("DD/MM/YYYY")})</span>)

    }

  }

  PfxDownload(label: string, empresa: string, conta_id: string, senha: string, tipo: string) {

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "1em", marginBottom: "0.5em" }}>

        <label style={{ minWidth: "60px", marginBottom: 0 }}>{label}:</label>

        <IconButton onClick={() => this.handleDownloadPfx(empresa, conta_id, senha, tipo)} style={{ background: "none", border: "none", cursor: "pointer" }}>
          <AppIcon name="sim_card_download" size={20} style={{ color: "#3579ea" }} />
        </IconButton>

      </div>
    );

  }

  openEditEmpresa(row) {

    this.obs.itens = row

    this.obs.selectedTab = "empresa"

    this.obs.lista_rbt12 = []
    this.obs.lista_rbt12_externa = []

    this.obs.rbt12_loaded = false
    this.obs.rbt12_alterado = false

    this.obs.open_modal_edit = true

  }

  handleValueDays = (valueAsNumber: number, valueAsString: string) => {

    this.obs.days = valueAsString.replace(/\D/g, "")

  };

  async handleBuscaDados() {

    this.obs.loading_dados = true

    const dados = await EmpresaAdminStore.buscaDadosEmpresa(this.obs.itens.cnpj, parseInt(this.obs.days))

    if (!dados) return

    this.obs.new_values = dados

    const marcados: Record<string, boolean> = {}

    this.montaDiff(this.obs.itens, dados).forEach(l => {
      if (l.alterado) marcados[l.key] = true
    })

    this.obs.aprovados = marcados

    this.obs.loading_dados = false

  }

  soData = (v: any) => (v ? String(v).slice(0, 10) : v)

  montaDiff(atual: any, novo: any) {

    return CAMPOS_CNPJ.map(({ key, label, tipo }) => {

      const vAtual = atual ? atual[key] : null
      const vNovo = novo ? novo[key] : null

      const alterado = key === "abertura"
        ? this.soData(vAtual) != this.soData(vNovo)
        : key === "cep"
          ? (vAtual == null ? "" : String(vAtual).replace(/\D/g, "")) != (vNovo == null ? "" : String(vNovo).replace(/\D/g, ""))
          : (vAtual == null ? "" : vAtual) != (vNovo == null ? "" : vNovo)

      return { key, label, tipo, atual: vAtual, novo: vNovo, alterado }

    })

  }

  formataExibicao(valor: any, tipo: any) {

    if (valor === null || valor === undefined || valor === "") return '—'

    if (tipo === 'data') {
      const d = new Date(valor)
      return isNaN(d.getTime()) ? String(valor) : d.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
    }

    if (tipo === 'digitos') {
      return String(valor).replace(/\D/g, "")
    }

    return String(valor)

  }

  toggleCampo(key: string) {
    this.obs.aprovados = { ...this.obs.aprovados, [key]: !this.obs.aprovados[key] }
  }

  /**
  * Fecha o modal de edição da empresa e redefine os estados relacionados
  * ao processo de atualização dos dados cadastrais.
  *
  * Ao fechar o modal, define `open_modal_edit` como `false`, restaura o
  * período padrão de consulta para 60 dias e limpa os dados retornados pela
  * última busca realizada.
  *
  * Também remove as seleções armazenadas em `aprovados`, garantindo que uma
  * nova edição seja iniciada sem manter informações da empresa anteriormente
  * selecionada.
  *
  * @returns {void} Não retorna um valor. A função apenas fecha o modal e
  * redefine os estados utilizados durante a edição.
  */

  handleCloseEdit() {

    this.obs.open_modal_edit = false

    this.obs.days = "60"
    this.obs.new_values = null
    this.obs.aprovados = {}

  }

  async handleSaveEdit() {

    const payload: any = {}

    this.linhasAlteradas.filter(l => this.obs.aprovados[l.key]).forEach(l => {

      const alterado = l.key === 'cep'
        ? String(l.novo).replace(/\D/g, "")
        : l.novo

      payload[l.key] = alterado

    })

    if (Object.keys(payload).length === 0) {
      toast.warn("Selecione pelo menos um campo para atualizar.", {})
      return
    }

    this.obs.loading_save = true

    const id = this.obs.itens._id

    this.handleCloseEdit()

    const resp = await EmpresaAdminStore.handleSaveDadosEmpresa(id, payload)

    if (resp) {

      await EmpresaAdminStore.handleLoadEmpresas(this.obs.currentPage, this.obs.filters_empresa, this.obs.filters_conta)

    }

    this.obs.loading_save = false

  }

  /**
  * Gerencia a alteração da aba selecionada no modal de edição da empresa.
  *
  * Converte o identificador recebido para `string` e atualiza o estado
  * `selectedTab` com a aba atualmente selecionada.
  *
  * Quando a aba selecionada é `rbt12` e os dados de RBT12 ainda não foram
  * carregados, executa `handleRbt12()` para buscar as informações necessárias.
  *
  * A verificação de `rbt12_loaded` evita que a mesma consulta seja realizada
  * novamente sempre que o usuário alternar entre as abas do modal.
  *
  * @async
  * @param {any} tabId - Identificador da aba selecionada.
  * @returns {Promise<void>} Não retorna um valor. A função apenas atualiza a
  * aba selecionada e, quando necessário, carrega os dados de RBT12.
  */

  async handleTabChange(tabId: any) {
    const tab = String(tabId)

    this.obs.selectedTab = tab

    if (tab === "rbt12" && !this.obs.rbt12_loaded) {
      await this.handleRbt12()
    }
  }

  /**
  * Carrega os dados de RBT12 da empresa selecionada.
  *
  * Ativa o estado de carregamento antes de iniciar a consulta e solicita ao
  * store os dados de RBT12 utilizando o identificador e o CNPJ da empresa
  * atualmente selecionada.
  *
  * Quando a consulta é concluída, atualiza os estados locais com os valores
  * retornados nos campos `lista_rbt12` e `lista_rbt12_externa`. Caso algum
  * desses campos não exista na resposta, utiliza uma lista vazia como valor
  * padrão.
  *
  * Após o carregamento, marca os dados de RBT12 como carregados através de
  * `rbt12_loaded` e redefine `rbt12_alterado` para `false`, indicando que
  * ainda não existem alterações pendentes de salvamento.
  *
  * Independentemente do resultado da operação, o estado de carregamento
  * `loading_rbt12` é desativado ao final do processamento através do bloco
  * `finally`.
  *
  * @async
  * @returns {Promise<void>} Não retorna um valor. A função apenas carrega os
  * dados RBT12 e atualiza os estados utilizados pela interface.
  */

  async handleRbt12() {

    this.obs.loading_rbt12 = true

    try {
      const dados = await EmpresaAdminStore.handleRbt12(this.obs.itens._id, this.obs.itens.cnpj)

      this.obs.lista_rbt12 = dados?.lista_rbt12 || []
      this.obs.lista_rbt12_externa = dados?.lista_rbt12_externa || []

      this.obs.rbt12_loaded = true
      this.obs.rbt12_alterado = false

    } finally {
      this.obs.loading_rbt12 = false
    }
  }

  /**
  * Salva as alterações realizadas nos dados de RBT12 da empresa selecionada.
  *
  * Ativa o estado de carregamento antes de iniciar o processamento e envia
  * para o store o identificador da empresa juntamente com as listas
  * `lista_rbt12` e `lista_rbt12_externa`.
  *
  * Quando a atualização é realizada com sucesso, redefine o indicador
  * `rbt12_alterado` para `false` e exibe uma mensagem informando que os
  * dados foram atualizados com sucesso.
  *
  * Após a tentativa de atualização, fecha o modal de edição da empresa.
  * Independentemente do resultado da operação, o estado de carregamento
  * é desativado ao final do processamento através do bloco `finally`.
  *
  * @async
  * @returns {Promise<void>} Não retorna um valor. A função apenas realiza
  * a atualização dos dados RBT12 e controla os estados da interface.
  */

  async handleSaveRbt12() {

    const datasValidasRbt12 = this.validaData(this.obs.lista_rbt12)
    const datasValidasRbt12Externa =this.validaData(this.obs.lista_rbt12_externa)

    if (!datasValidasRbt12) {
      toast.warn("Existe uma data com formato inválido na lista RBT12.", {});
      return;
    }

    if(!datasValidasRbt12Externa){
      toast.warn("Existe uma data com formato inválido na lista externa RBT12.", {});
      return;
    }

    this.obs.loading_save = true

    try {
      const resp = await EmpresaAdminStore.handleSaveRbt12(
        this.obs.itens._id,
        this.obs.lista_rbt12,
        this.obs.lista_rbt12_externa
      )

      if (resp) {
        this.obs.rbt12_alterado = false
        toast.success("Dados RBT12 atualizados com sucesso!", {})
      }

      this.handleCloseEdit()

    } finally {
      this.obs.loading_save = false
    }
  }

  validaData(items){
    
    return items.every(([data]) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(data)) {
        return false;
      }

      const date = new Date(`${data}T00:00:00Z`);

      return !isNaN(date.getTime()) &&
        date.toISOString().slice(0, 10) === data;
    });

  }

  render() {

    let estadosOption = [
      { label: "TODOS", value: "" },
      { label: "AC", value: "AC" },
      { label: "AL", value: "AL" },
      { label: "AP", value: "AP" },
      { label: "AM", value: "AM" },
      { label: "BA", value: "BA" },
      { label: "CE", value: "CE" },
      { label: "DF", value: "DF" },
      { label: "ES", value: "ES" },
      { label: "GO", value: "GO" },
      { label: "MA", value: "MA" },
      { label: "MT", value: "MT" },
      { label: "MS", value: "MS" },
      { label: "MG", value: "MG" },
      { label: "PA", value: "PA" },
      { label: "PB", value: "PB" },
      { label: "PR", value: "PR" },
      { label: "PE", value: "PE" },
      { label: "PI", value: "PI" },
      { label: "RJ", value: "RJ" },
      { label: "RN", value: "RN" },
      { label: "RS", value: "RS" },
      { label: "RO", value: "RO" },
      { label: "RR", value: "RR" },
      { label: "SC", value: "SC" },
      { label: "SP", value: "SP" },
      { label: "SE", value: "SE" },
      { label: "TO", value: "TO" }
    ]

    function ativaFormatter(cell, row) {

      return (
        <>
          {cell
            ? <img src="/images/checked.png" width="20px" />
            : <img src="/images/block.png" width="20px" />
          }
        </>
      );
    }

    let empresas = EmpresaAdminStore.obs.empresas?.map(emp => {
      return ({
        _id: emp._id,
        razao_social: emp.razao_social,
        cnpj: formatCnpj(emp.cnpj),
        regime_importacao: emp.regime_importacao,
        uf: emp.uf,
        municipio: emp.municipio,
        ativo: emp.ativo,
        conta_ativa: emp.conta.ativo,
        conta_nome: emp.conta.nome || emp.conta.razao_social,
        empresa: emp,
      })
    });

    const btnDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn color="default" rounded size="sm" onClick={(e) => this.openDetalhesEmpresa(row.empresa)}>
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    const btnEdit = (cell, row) => {
      return (
        <>
          <MDBBtn color="default" rounded size="sm" onClick={(e) => this.openEditEmpresa(row.empresa)}>
            <img src="/images/edit.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    return (

      <>

        <FormGroup>
          <IconButton style={{ float: "right" }} onClick={() => this.handleClearFiltros()}>
            <AppIcon name="close" color="rgb(211, 47, 47)" />
          </IconButton>

          <IconButton style={{ float: "right" }} onClick={() => this.obs.open_filters = !this.obs.open_filters}>
            <AppIcon name="filter_list" />
          </IconButton>

        </FormGroup>

        {this.obs.open_filters && <>

          <FormGroup label="Empresa">

            <div style={{ border: "1px solid rgba(27, 99, 111, 0.5)", padding: 10, borderRadius: 10 }}>

              <div style={{ display: "flex" }}>

                <FormGroup label="Razão Social" style={{ width: "50%" }}>
                  <InputGroup placeholder="Filtrar Razão Social" value={this.obs.filters_empresa.razao_social} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.razao_social = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="CNPJ" style={{ width: "50%" }}>
                  <InputGroup placeholder="Filtrar CNPJ" value={this.obs.filters_empresa.cnpj} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.cnpj = e.target.value)} />
                </FormGroup>

              </div>

              <div style={{ display: "flex" }}>

                <FormGroup label="Município" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar Município" value={this.obs.filters_empresa.municipio} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.municipio = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="UF" style={{ width: "25%" }}>
                  <HTMLSelect onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.uf = e.target.value)} value={this.obs.filters_empresa.uf}>
                    {estadosOption?.map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </HTMLSelect>
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Regime da Empresa" style={{ width: "25%" }}>
                  <HTMLSelect value={this.obs.filters_empresa.regime_importacao} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.regime_importacao = e.target.value)}>
                    <option value="">TODAS</option>
                    <option value="CAIXA">CAIXA</option>
                    <option value="COMPETÊNCIA">COMPETÊNCIA</option>
                  </HTMLSelect>
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Ativa" style={{ width: "25%" }}>
                  <HTMLSelect value={this.obs.filters_empresa.ativo} onChange={(e) => this.handleQueryFilters(this.obs.filters_empresa.ativo = e.target.value)}>
                    <option value="0">TODAS</option>
                    <option value="1">ATIVAS</option>
                    <option value="2">DESATIVADAS</option>
                  </HTMLSelect>
                </FormGroup>
              </div>

            </div>

          </FormGroup>

          <FormGroup label="Conta">

            <div style={{ border: "1px solid rgba(27, 99, 111, 0.5)", padding: 10, borderRadius: 10 }}>

              <div style={{ display: "flex" }}>
                <FormGroup label="Nome" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar Conta Nome" value={this.obs.filters_conta.nome} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.nome = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Razão Social" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar Razão Social" value={this.obs.filters_conta.razao_social} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.razao_social = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="CNPJ" style={{ width: "25%" }}>
                  <InputGroup placeholder="Filtrar CNPJ" value={this.obs.filters_conta.cnpj} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.cnpj = e.target.value)} />
                </FormGroup>
                &nbsp;&nbsp;&nbsp;
                <FormGroup label="Ativa" style={{ width: "25%" }}>
                  <HTMLSelect value={this.obs.filters_conta.ativo} onChange={(e) => this.handleQueryFilters(this.obs.filters_conta.ativo = e.target.value)}>
                    <option value="0">TODAS</option>
                    <option value="1">ATIVAS</option>
                    <option value="2">DESATIVADAS</option>
                  </HTMLSelect>
                </FormGroup>
              </div>

            </div>

          </FormGroup>

        </>}

        <BootstrapTable className="TableDefault" ref="table" data={empresas}>
          <TableHeaderColumn dataField="_id" isKey={true} hidden>#</TableHeaderColumn>
          <TableHeaderColumn dataField="razao_social" width={"30%"}>Razão Social</TableHeaderColumn>
          <TableHeaderColumn dataField="cnpj" width={"10%"}>CNPJ</TableHeaderColumn>
          <TableHeaderColumn dataField="regime_importacao" width={"10%"}>Regime Importação</TableHeaderColumn>
          <TableHeaderColumn dataField="uf" width={"5%"}>UF</TableHeaderColumn>
          <TableHeaderColumn dataField="municipio" width={"10%"}>Município</TableHeaderColumn>
          <TableHeaderColumn dataFormat={ativaFormatter} dataField="ativo" width="5%">Ativa</TableHeaderColumn>
          <TableHeaderColumn dataField="conta_nome" width={"20%"}>Conta / Razão Social</TableHeaderColumn>
          <TableHeaderColumn dataFormat={ativaFormatter} dataField="conta_ativa" width="5%">Ativa</TableHeaderColumn>
          <TableHeaderColumn dataFormat={btnEdit} width={"5%"}>Editar</TableHeaderColumn>
          <TableHeaderColumn dataFormat={btnDetalhes} width={"5%"}>Detalhes</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.currentPage}
            totalCount={EmpresaAdminStore.obs.empresas_length}
            pageSize={20}
            onPageChange={page => this.handlePageChange(page)}
          />
        </div>

        <Dialog
          isOpen={this.obs.open_modal_detalhes}
          onClose={() => this.obs.open_modal_detalhes = false}
          style={{ width: 700 }}
          className="confirmCadEmp"
        >
          <div className={Classes.DIALOG_BODY}>
            <Tabs id="tabs" className="tabsCalculos tabsCentral">
              <Tab id="dados" title="Dados" panel={
                <MDBRow>
                  <MDBCol md="6" className="empresa-admin-modal">
                    <p><span>Dados da Empresa</span></p>
                    <p><span>Identificador:</span> {this.obs.itens?._id}</p>
                    <p><span>CNPJ:</span> {this.obs.itens?.cnpj}</p>
                    <p><span>Razão Social:</span> {this.obs.itens?.razao_social}</p>
                    <p><span>Nome Fantasia:</span> {this.obs.itens?.nome_fantasia}</p>
                    <p><span>Apelido:</span> {this.obs.itens?.apelido}</p>
                    <p><span>Inscrição Estadual:</span> {this.obs.itens?.inscricao_estadual}</p>
                    <p><span>Tipo de Cadastro:</span>{" "}{this.obs.itens?.filial ? "FILIAL" : "MATRIZ"}</p>
                    <p><span>Regime da Empresa:</span> {this.obs.itens?.regime_importacao}</p>
                    <p><span>Logradouro:</span> {this.obs.itens?.logradouro}</p>
                    <p><span>Municipio:</span> {this.obs.itens?.municipio}</p>
                    <p><span>Estado:</span> {this.obs.itens?.uf}</p>
                    <p><span>Cadastrada:</span> {moment(this.obs.itens?.inserted_at).format("DD/MM/YYYY")}</p>
                  </MDBCol>
                  <MDBCol md="6" className="empresa-admin-modal">
                    <p><span>Dados da Conta</span></p>
                    <p><span>Identificador:</span> {this.obs.itens.conta?.id}</p>
                    <p><span>Nome:</span> {this.obs.itens.conta?.nome}</p>
                    <p><span>CNPJ:</span> {this.obs.itens.conta?.cnpj}</p>
                    <p><span>Razão Social:</span> {this.obs.itens.conta?.razao_social}</p>
                    <p><span>Logradouro:</span> {this.obs.itens.conta?.logradouro || this.obs.itens.conta?.rua}</p>
                    <p><span>Número:</span> {this.obs.itens.conta?.numero}</p>
                    <p><span>Bairro:</span> {this.obs.itens.conta?.bairro}</p>
                    <p><span>Cidade:</span> {this.obs.itens.conta?.cidade}</p>
                    <p><span>Estado:</span> {this.obs.itens.conta?.uf || this.obs.itens.conta?.estado}</p>
                    <p><span>Cep:</span> {this.obs.itens.conta?.cep}</p>
                    <p><span>Telefone:</span> ({this.obs.itens.conta?.ddd}) {this.obs.itens.conta?.telefone}</p>
                    <p><span>Cadastrada:</span> {moment(this.obs.itens.conta?.inserted_at).format("DD/MM/YYYY")}</p>
                  </MDBCol>
                </MDBRow>
              } />
              <Tab id="certificados" title="Certificados" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <div className="info-bloco">
                    {this.obs.itens?.certificado ? (
                      <>
                        <p style={{ marginBottom: 0 }}><strong>Essa empresa possui um certificado em uso: </strong>
                          {this.certificadoFormat(this.obs.itens?.certificado)}
                        </p>
                        {this.PfxDownload("PFX", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens?.senha_certificado, "certificado")}
                        <SenhaCopiavel valor={this.obs.itens?.senha_certificado} label="Senha" />
                      </>
                    ) : (
                      <p><strong>Essa empresa não possui certificado.</strong></p>
                    )}
                  </div>

                  <br />

                  <div className="info-bloco">
                    {this.obs.itens?.certificado_socio ? (
                      <>
                        <p style={{ marginBottom: 0 }}><strong>Essa empresa possui um certificado do sócio em uso: </strong>
                          {this.certificadoFormat(this.obs.itens?.certificado_socio)}
                        </p>
                        {this.PfxDownload("PFX sem Senha", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens?.senha_certificado_socio, "socio")}
                        {this.PfxDownload("PFX", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens?.senha_certificado_socio, "socio_senha")}
                        <SenhaCopiavel valor={this.obs.itens?.senha_certificado_socio} label="Senha" />
                      </>
                    ) : (
                      <p><strong>Essa empresa não possui certificado do sócio.</strong></p>
                    )}
                  </div>

                  <br />

                  <div className="info-bloco">
                    {this.obs.itens?.conta?.certificado ? (
                      <>
                        <p style={{ marginBottom: 0 }}><strong>Essa conta possui um certificado do contador em uso: </strong>
                          {this.certificadoFormat(this.obs.itens.conta?.certificado)}
                        </p>
                        {this.PfxDownload("PFX", this.obs.itens?.cnpj, this.obs.itens.conta?.id, this.obs.itens.conta?.senha_certificado, "conta")}
                        <SenhaCopiavel valor={this.obs.itens.conta?.senha_certificado} label="Senha" />
                      </>
                    ) : (
                      <p><strong>Essa conta não possui um certificado do contador.</strong></p>
                    )}
                  </div>
                </MDBCol>
              } />
              <Tab id="config" title="Configurações" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <div style={{ display: "flex" }}>
                    <span>Caixa Postal (RFB)</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.caixapostal_automatica ? "Ativado" : "Desativado"} checked={this.obs.itens?.caixapostal_automatica} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Situação Fiscal (RFB) Automático</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.sitfis_automatico ? "Ativado" : "Desativado"} checked={this.obs.itens?.sitfis_automatico} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Manifestação NF-E e CT-E Automática</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.manifestacao_automatica ? "Ativado" : "Desativado"} checked={this.obs.itens?.manifestacao_automatica} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Importação de XML Automática SEFA</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.calculo_automatico_nivy ? "Ativado" : "Desativado"} checked={this.obs.itens?.calculo_automatico_nivy} />
                  </div>
                  {this.obs.itens?.calculo_automatico_nivy && <>
                    <div className="nz-horizontal-form">
                      <div style={{ width: 100 }}>
                        <Checkbox className="select-regras" disabled checked={this.obs.itens?.calculo_automatico_nivy_entrada} label="Entrada" />
                      </div>
                      <div style={{ width: 100 }}>
                        <Checkbox className="select-regras" disabled checked={this.obs.itens?.calculo_automatico_nivy_saida} label="Saída" />
                      </div>
                    </div>
                    <RadioGroup disabled onChange={() => { }} selectedValue={(this.obs.itens?.rewritexml ? "1" : "0")} inline={true}>
                      <Radio label="Sobrescrever registros existentes" value="1" />
                      <Radio label="Importar somente registros inexistentes" value="0" />
                    </RadioGroup>
                  </>}
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Download NFS-E Ambiente Nacional Automática</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.manifestacao_automatica_nfse ? "Ativado" : "Desativado"} checked={this.obs.itens?.manifestacao_automatica_nfse} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Consultar NF-e Portal da Nota Fiscal Eletrônica</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.nfe_fazenda_automatico ? "Ativado" : "Desativado"} checked={this.obs.itens?.nfe_fazenda_automatico} />
                  </div>
                  {this.obs.itens?.nfe_fazenda_automatico &&
                    <RadioGroup disabled onChange={(e) => { }} selectedValue={this.obs.itens?.download_via_manifestador} inline={true}>
                      <Radio label="Download XML via Manifestador" value="1" />
                      <Radio label="Download XML via Automação" value="0" />
                      <Radio label="Download XML via Automação e Ciência" value="2" />
                    </RadioGroup>
                  }
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Det automático</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.det_auto ? "Ativado" : "Desativado"} checked={this.obs.itens?.det_auto} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Dec Sefa automático</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.dec_sefa_auto ? "Ativado" : "Desativado"} checked={this.obs.itens?.dec_sefa_auto} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                </MDBCol>
              } />
              <Tab id="sefa" title="SEFA | e-CAC" panel={
                <MDBCol md="12" className="empresa-admin-modal">

                  <div style={{ display: "flex" }}>
                    <span>SEFA Retroativa</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.sefa_retroativa ? "Ativado" : "Desativado"} checked={this.obs.itens?.sefa_retroativa} />
                  </div>

                  <Divider style={{ margin: 0, marginBottom: 10 }} />

                  <div style={{ display: "flex" }}>
                    <span>SEFA Bloqueio Erro Fatal</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.sefa_bloqueio_erro_fatal ? "Ativado" : "Desativado"} checked={this.obs.itens?.sefa_bloqueio_erro_fatal} />
                  </div>

                  <Divider style={{ margin: 0, marginBottom: 5 }} />

                  <div style={{ marginBottom: 5 }}><strong>Como você deseja consultar no DEC Sefa?</strong></div>
                  <RadioGroup disabled inline selectedValue={this.obs.itens?.dec_type} onChange={(e) => { }}>
                    <Radio label="Consultar DEC Sefa via API" value="api" />
                    <Radio label="Consultar DEC Sefa via Automação" value="browser" />
                  </RadioGroup>

                  <Divider style={{ margin: 0, marginBottom: 5 }} />

                  <div style={{ marginBottom: 5 }}><strong>Como você deseja se autenticar na SEFA?</strong></div>
                  <RadioGroup disabled inline selectedValue={this.obs.itens?.sefa_metodo_login} onChange={(e) => { }}>
                    <Radio label="Certificado do Sócio" value="certificado" />
                    <Radio label="GOV (Certificado)" value="gov" />
                    <Radio label="GOV (CPF / Senha)" value="gov_senha" />
                  </RadioGroup>

                  <Divider style={{ margin: 0, marginBottom: 5 }} />

                  <div style={{ marginBottom: 5 }}><strong>Como você deseja se autenticar no DEI?</strong></div>
                  <RadioGroup disabled inline selectedValue={this.obs.itens?.autenticacao_dei} onChange={(e) => { }}>
                    <Radio label="Certificado do Sócio" value="2" />
                    <Radio label="CPF e Senha" value="1" />
                    <Radio label="GOV (Certificado)" value="0" />
                    <Radio label="GOV (CPF / Senha)" value="3" />
                  </RadioGroup>

                  <Divider style={{ margin: 0, marginBottom: 5 }} />

                  <div style={{ marginBottom: 5 }}><strong>Como você deseja se autenticar no e-CAC?</strong></div>
                  <RadioGroup disabled inline selectedValue={this.obs.itens?.autenticacao_ecac} onChange={(e) => { }}>
                    <Radio label="Certificado da Empresa" value="0" />
                    <Radio label="Certificado do Contator" value="1" />
                  </RadioGroup>

                  <Divider style={{ margin: 0, marginBottom: 5 }} />

                  <div style={{ marginBottom: 5 }}><strong>Como você deseja se autenticar no PARCELAMENTO SEFA?</strong></div>
                  <RadioGroup disabled inline selectedValue={this.obs.itens?.autenticacao_sefa} onChange={(e) => { }}>
                    <Radio label="Certificado da Empresa" value="0" />
                    <Radio label="Certificado do Sócio" value="1" />
                    <Radio label="Usuário e Senha (Sócio)" value="2" />
                  </RadioGroup>

                </MDBCol>
              } />
              <Tab id="auth" title="Logins" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <div className="info-bloco">
                    <p style={{ marginBottom: 0 }}><strong>Login SEFA:</strong></p>
                    <UserCopiavel valor={this.obs.itens?.cpf_sefa} label="Usuário" />
                    <SenhaCopiavel valor={this.obs.itens?.senha_sefa} label="Senha" />
                  </div>
                  <br />
                  <div className="info-bloco">
                    <p style={{ marginBottom: 0 }}><strong>Login GOV:</strong></p>
                    <UserCopiavel valor={this.obs.itens?.cpf_gov} label="Usuário" />
                    <SenhaCopiavel valor={this.obs.itens?.senha_gov} label="Senha" />
                  </div>
                  <br />
                  <div className="info-bloco">
                    <p style={{ marginBottom: 0 }}><strong>Login SEFA (Sócio):</strong></p>
                    <UserCopiavel valor={this.obs.itens?.cpf_socio} label="Usuário" />
                    <SenhaCopiavel valor={this.obs.itens?.senha_socio} label="Senha" />
                  </div>
                </MDBCol>
              } />
              <Tab id="pgdas_sped" title="PGDAS | SPED" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <div style={{ display: "flex" }}>
                    <span>Indicador de Comparação</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.indicadorComparacao ? "Ativado" : "Desativado"} checked={this.obs.itens?.indicadorComparacao} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <div style={{ display: "flex" }}>
                    <span>Cálculo Automático</span>&nbsp;
                    <Switch disabled className="select-regras" label={this.obs.itens?.cfop_calculo_sped ? "Ativado" : "Desativado"} checked={this.obs.itens?.cfop_calculo_sped} />
                  </div>
                  <Divider style={{ margin: 0, marginBottom: 10 }} />
                  <p><span>Data do saldo credor anterior (Apuração):</span> {this.obs.itens?.sped_valor_inicial_data}</p>
                  <p><span>Saldo credor anterior (Apuração):</span> {this.obs.itens?.sped_valor_inicial}</p>
                </MDBCol>
              } />
              <Tab id="tributacoes" title="Tributações" panel={
                <MDBCol md="12" className="empresa-admin-modal">
                  <p><span>Regime Simples Nacional:</span>{" "}{this.obs.itens?.simples_nacional ? "Sim" : "Não"}</p>
                  <p><span>Excesso de Sublimite de Receita Bruta:</span>{" "}{this.obs.itens?.simples_nacional_excesso ? "Sim" : "Não"}</p>
                  <p><span>Regime Especial:</span>{" "}{this.obs.itens?.regime_especial_icms_pa ? "Sim" : "Não"}</p>
                  <p><span>Convênio ICMS 100/97:</span>{" "}{this.obs.itens?.convenio_icms_100_97 ? "Sim" : "Não"}</p>
                  <p><span>Comercializa Medicamentos Veterinários, PET.:</span>{" "}{this.obs.itens?.medicamento_uso_veterinario ? "Sim" : "Não"}</p>
                  <p><span>Comercializa Produtos Auto Peças:</span> {this.obs.itens?.auto_pecas ? "Sim" : "Não"}</p>
                  <p><span>Operação de Venda na Modalidade Porta a Porta:</span> {this.obs.itens?.porta_a_porta ? "Sim" : "Não"}</p>
                </MDBCol>
              } />
            </Tabs>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_modal_detalhes = false} />
            </div>
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_modal_edit}
          onClose={() => this.handleCloseEdit()}
          style={{ width: 700 }}
          className="confirmCadEmp atualizarDadosEmpresaDialog"
          title="Atualizar dados Empresa"
        >

          <MDBRow>
            <Tabs
              id="tabs"
              className={"tabsCalculos tabsEmpresaForm"}
              selectedTabId={this.obs.selectedTab}
              onChange={(tabId) => this.handleTabChange(tabId)}
            >
              <Tab
                id="empresa"
                title="Dados da Empresa"
                panel={
                  <MDBCol>

                    <div className={Classes.DIALOG_BODY}>
                      <div style={{ display: "flex", gap: 10 }}>

                        <FormGroup label="CNPJ" style={{ width: "20%" }}>
                          <InputGroup value={formatCnpj(this.obs.itens.cnpj)} disabled />
                        </FormGroup>

                        <FormGroup label="Dias" labelInfo="*" style={{ width: "15%" }}>
                          <NumericInput
                            className="input-numeric"
                            value={this.obs.days}
                            onValueChange={this.handleValueDays}
                            buttonPosition="none"
                            placeholder="Exemplo: 60"
                            style={{ width: "100%" }}
                            min={1}
                            minorStepSize={null}
                            allowNumericCharactersOnly
                          />
                        </FormGroup>

                        <FormGroup label={"\u200B"}>
                          <MDBBtn className="btnDefault" style={{ marginTop: 5 }} onClick={() => this.handleBuscaDados()} disabled={this.obs.loading_dados}>
                            Buscar dados atualizados
                          </MDBBtn>
                        </FormGroup>

                      </div>

                      {!this.obs.new_values && (
                        <div>
                          <Callout intent="warning">
                            Realize a busca dos dados atualizados.
                          </Callout>
                        </div>
                      )}

                      {this.obs.new_values && this.linhasAlteradas.length === 0 && (
                        <div>
                          <Callout intent="success">
                            Cadastro já está atualizado. Nenhuma diferença encontrada.
                          </Callout>
                        </div>
                      )}

                      {this.obs.new_values && (

                        <div>

                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>

                            <strong>
                              {this.linhasAlteradas.length === 0
                                ? 'Nenhuma alteração encontrada'
                                : `${this.linhasAlteradas.length} alteração(ões) encontrada(s)`}
                            </strong>

                            <span className="bp3-text-muted" style={{ fontSize: 12 }}>
                              {this.diffCampos.length} campos consultados
                            </span>

                          </div>

                          <HTMLTable striped style={{ width: '100%', tableLayout: 'fixed', fontSize: 12 }}>
                            <thead>
                              <tr>
                                <th style={{ width: 40 }} />
                                <th style={{ width: 140 }}>Campo</th>
                                <th>Atual</th>
                                <th>Novo</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.diffCampos.map((linha: any) => (
                                <tr
                                  key={linha.key}
                                  style={{ background: linha.alterado ? undefined : 'transparent', fontSize: 12 }}
                                >
                                  <td style={{ verticalAlign: 'top', textAlign: 'center' }}>
                                    {linha.alterado ? (
                                      <Checkbox
                                        checked={!!this.obs.aprovados[linha.key]}
                                        onChange={() => this.toggleCampo(linha.key)}
                                        style={{ margin: 0 }}
                                      />
                                    ) : (
                                      <Icon icon="tick" iconSize={12} className="bp3-text-muted" title="Sem alteração" />
                                    )}
                                  </td>

                                  <td style={{ verticalAlign: 'top', opacity: linha.alterado ? 1 : 0.45, fontWeight: "bold" }}>
                                    {linha.label}
                                  </td>

                                  <td style={{
                                    verticalAlign: 'top',
                                    wordBreak: 'break-word',
                                    opacity: linha.alterado ? 0.6 : 0.45,
                                    textDecoration: linha.alterado ? 'line-through' : 'none',
                                  }}>
                                    {this.formataExibicao(linha.atual, linha.tipo)}
                                  </td>

                                  <td style={{
                                    verticalAlign: 'top',
                                    wordBreak: 'break-word',
                                    fontWeight: linha.alterado ? 500 : 400,
                                    opacity: linha.alterado ? 1 : 0.45,
                                  }}>
                                    {linha.alterado
                                      ? this.formataExibicao(linha.novo, linha.tipo)
                                      : <span className="bp3-text-muted">{this.formataExibicao(linha.novo, linha.tipo)}</span>}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </HTMLTable>

                        </div>
                      )}

                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text="Fechar" onClick={() => this.handleCloseEdit()} />
                        {this.linhasAlteradas.length > 0 && (
                          <Button text="Salvar" intent="primary" onClick={() => this.handleSaveEdit()} />
                        )}
                      </div>
                    </div>
                  </MDBCol>

                }
              />

              <Tab
                id="rbt12"
                title="RBT12"
                panel={
                  <MDBCol>
                    <div className={Classes.DIALOG_BODY}>

                      <div style={{ maxHeight: 400, overflow: "auto" }}>

                        {this.obs.loading_rbt12 ? (
                          <Callout>
                            Carregando dados RBT12...
                          </Callout>
                        ) : (
                          <>
                            <FormGroup label="Lista RBT12">
                              <JsonEditor
                                data={this.obs.lista_rbt12}
                                enableClipboard={true}
                                restrictDrag={true}
                                restrictAdd={true}
                                restrictDelete={true}
                                restrictTypeSelection={true}
                                collapse={true}
                                setData={(data) => {
                                  this.obs.lista_rbt12 = data as any[]
                                  this.obs.rbt12_alterado = true
                                }}
                              />
                            </FormGroup>

                            <Divider
                              style={{
                                marginTop: 20,
                                marginBottom: 20
                              }}
                            />

                            <FormGroup label="Lista RBT12 Externa">
                              <JsonEditor
                                data={this.obs.lista_rbt12_externa}
                                enableClipboard={true}
                                restrictDrag={true}
                                restrictAdd={true}
                                restrictDelete={true}
                                restrictTypeSelection={true}
                                collapse={true}
                                setData={(data) => {
                                  this.obs.lista_rbt12_externa = data as any[]
                                  this.obs.rbt12_alterado = true
                                }}
                              />
                            </FormGroup>

                          </>
                        )}
                        <div className={Classes.DIALOG_FOOTER}>
                          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button text="Fechar" onClick={() => this.handleCloseEdit()} />
                            <Button
                              text="Salvar"
                              intent="primary"
                              disabled={!this.obs.rbt12_alterado || this.obs.loading_save}
                              onClick={() => this.handleSaveRbt12()}
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                  </MDBCol>
                }
              />

            </Tabs>

          </MDBRow>

        </Dialog>

        <LoadingModal open={this.obs.loading_dados} onClose={() => this.obs.loading_dados = false} title={"Carregando"} />
        <LoadingModal open={this.obs.loading_save} onClose={() => this.obs.loading_save = false} title={"Salvando"} />

      </>

    )
  }

}